import { render, staticRenderFns } from "./MicroModalComponent.vue?vue&type=template&id=6f2a23e2&"
import script from "./MicroModalComponent.ts?vue&type=script&lang=ts&"
export * from "./MicroModalComponent.ts?vue&type=script&lang=ts&"
import style0 from "./MicroModalComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports